/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferrerRateRequest
 */
export interface UpdateReferrerRateRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateReferrerRateRequest
     */
    rate: number;
}

/**
 * Check if a given object implements the UpdateReferrerRateRequest interface.
 */
export function instanceOfUpdateReferrerRateRequest(value: object): value is UpdateReferrerRateRequest {
    if (!('rate' in value) || value['rate'] === undefined) return false;
    return true;
}

export function UpdateReferrerRateRequestFromJSON(json: any): UpdateReferrerRateRequest {
    return UpdateReferrerRateRequestFromJSONTyped(json, false);
}

export function UpdateReferrerRateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferrerRateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rate': json['rate'],
    };
}

export function UpdateReferrerRateRequestToJSON(value?: UpdateReferrerRateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rate': value['rate'],
    };
}

